import React, { useState } from 'react';
import {
  Paper,
  SnackbarContent,
  Table,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material';
import PropTypes from 'prop-types';
import useStyles from './styles';
import TableContent from './TableContent';
import GenericConfirmationModal from '../../../../../../commons/GenericConfirmationModal';
import ConfirmationInfo from './ConfirmationInfo';
import { viewedProductGroupCustom } from '../../../../../../../utils/custom_prop_types/customPropTypes';

export default function AddAssociationTable({
  modals,
  errorMessage,
  viewedProductGroup,
  addAssociation,
}) {
  const [typedMultiplier, setTypedMultiplier] = useState(null);
  const [selectedProductAssociation, setSelectedProductAssociation] = useState(null);
  const classes = useStyles();

  return (
    <>
      <TableContainer
        component={Paper}
        className={classes.associationTable}
      >
        <TableRow className={classes.errorBox}>
          <TableCell>
            {errorMessage?.map((error) => (
              <SnackbarContent
                className={classes.errorMessage}
                message={error.message}
                key={error.code}
              />
            ))}
          </TableCell>
        </TableRow>
        <Table aria-label="Product info">
          <TableContent
            selectedProductAssociation={selectedProductAssociation}
            setSelectedProductAssociation={setSelectedProductAssociation}
            setTypedMultiplier={setTypedMultiplier}
          />
        </Table>
      </TableContainer>
      {modals.addAssociationConfirmation
      && (
        <GenericConfirmationModal
          confirmationType="addAssociationConfirmation"
          confirmedFunction={() => addAssociation(
            Number(typedMultiplier),
            viewedProductGroup?.productIRI,
            selectedProductAssociation.groupIRI,
          )}
          informationalHeader="You are going to make an association between"
          contentUnderButtons={(
            <ConfirmationInfo
              selectedProductAssociation={selectedProductAssociation}
            />
          )}
        />
      )}
    </>
  );
}

AddAssociationTable.propTypes = {
  modals: PropTypes.objectOf(PropTypes.bool).isRequired,
  errorMessage: PropTypes.arrayOf(PropTypes.any).isRequired,
  viewedProductGroup: viewedProductGroupCustom.isRequired,
  addAssociation: PropTypes.func.isRequired,
};
